import React, {  } from "react";
import type * as controls from "../PhoenixFormsV4.Controls";
import PNXLabel from "./PNXLabel";


interface Props {
  controlProps: controls.RecommendationsetDisplay;
};

const PhoenixRecommendationsetDisplay = ({
  controlProps,
} : Props) => {

  const recommendation = controlProps.recommendation;

  if (!recommendation) return null;

  const isHexadecimal = (str) => {
    if (!str)
        return false;

    var rx = /^[0-9A-Fa-f]+$/g;
    return rx.test(str);
}

let color = "";
let backgroundColor = "";

if (recommendation.textColor && recommendation.textColor.length === 6 && isHexadecimal(recommendation.textColor)) {
  color = `#${recommendation.textColor}`;
}
if (recommendation.backgroundColor && recommendation.backgroundColor.length === 6 && isHexadecimal(recommendation.backgroundColor)) {
  backgroundColor = `#${recommendation.backgroundColor}`;
}

return <div>
    <PNXLabel>{controlProps.label}</PNXLabel>
    <div>
      <span>{recommendation.name ?? ""}</span>
      <span style={{color: color, backgroundColor: backgroundColor}}>{recommendation.level}</span>
      <span style={{color: color, backgroundColor: backgroundColor}}>Recommendation</span>
    </div>
  </div>
};

export default PhoenixRecommendationsetDisplay;